export function validateSearchFields({
  searchType,
  origin,
  destination,
  departureDate,
  returnDate,
  flightType,
}) {
  const errors = {};

  if (searchType === "flightsAndStays") {
    if (!origin) errors.origin = "Origin is required";
    if (!destination) errors.destination = "Destination is required";
    if (!departureDate) errors.departureDate = "Departure date is required";
    if (origin && destination && origin.city === destination.city) {
      errors.origin = "Origin and destination cannot be the same";
      errors.destination = "Origin and destination cannot be the same";
    }
    if (!returnDate || returnDate < departureDate) {
      errors.returnDate =
        flightType === "oneway"
          ? "Check-out date is required and must be after the departure date"
          : "Return date must be after the departure date";
    }
  }

  if (searchType === "staysOnly") {
    if (!destination) errors.destination = "Destination is required";
    if (!departureDate) errors.departureDate = "Check-in date is required";
    if (!returnDate || returnDate < departureDate) {
      errors.returnDate =
        "Check-out date is required and must be after check-in date";
    }
  }

  if (searchType === "explore") {
    if (!origin) errors.origin = "Origin is required";
    if (!departureDate) errors.departureDate = "Travel dates are required";
  }

  return errors;
}
